import * as React from 'react';
import { ICenterFollowUpLabOption } from '@nkr/models/index';
import { Button, DropdownButton, Glyphicon, MenuItem, OverlayTrigger, Popover } from 'react-bootstrap';

interface IProps {
    followUpOption: ICenterFollowUpLabOption,
    onPreviewFile:(labOrderId: number, centerId: number) => void,
    onAction: (id: number, action: any) => void
}


const ListRow: React.FunctionComponent<IProps> = (props) => {


    const handlePreview = (labOrderId: number) => {
        props.onPreviewFile(labOrderId, props.followUpOption.centerId);
    }

    const followUpOption = props.followUpOption;

    return (
        <tr>
            <td>{followUpOption.optionText}</td>
            <td>
                <span>{followUpOption.isLabOrdersOrPrintableLetters ? <Glyphicon glyph='ban-circle' />: <Glyphicon glyph='ok' />}</span>
            </td>
            <td>
                <span>{followUpOption.isLabOrdersOrPrintableLetters ? <Button bsStyle='primary' bsSize="xs" onClick={() => handlePreview(props.followUpOption.id)}>Preview File</Button>: "N/A"}</span>
            </td>

            <td>
                <DropdownButton bsStyle='primary' bsSize='xs' title='Actions' id={'followup-action-' + followUpOption.id} onSelect={(e) => props.onAction(followUpOption.id, e)}>
                    <MenuItem eventKey='EDIT'>Edit</MenuItem>
                    <MenuItem eventKey='DELETE'>Delete</MenuItem>
                </DropdownButton>
            </td>
        </tr>
    );
}

export default ListRow;